import { StyleSheet, View } from 'react-native';

import { centeredRowContainerStyles } from 'components/ui/centered-row-container';
import { LoyaltySkeletonHeader } from 'pages/loyalty/loyalty-skeleton/loyalty-skeleton-header';
import { spacing } from 'styles/constants';
import { WEB_SMALL_MAX_WIDTH } from 'utils/constants';

import { LoyaltySkeleOfferCard } from './loyalty-skeleton-offer-card';

export const LoyaltyOffersSkeletonLoader = () => {
  return (
    // App-owned marker for the E2E offers contract: it distinguishes "the offer
    // list never left its loading state" from "this store has no available
    // offers", which are otherwise indistinguishable from the outside.
    <View style={styles.container} testID="loyalty-offers-skeleton">
      <LoyaltySkeletonHeader />
      {Array.from({ length: 7 }).map((_, i) => (
        <LoyaltySkeleOfferCard key={i} />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    ...centeredRowContainerStyles.content,
    maxWidth: WEB_SMALL_MAX_WIDTH,
    paddingHorizontal: spacing.$4,
  },
});
